import { Component, AfterViewInit } from '@angular/core';
import { SessionHelper } from '../../core/helper/sessionHelper';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { DatosBolsaVacacionesKpiService } from '../../core/services/datosBolsaVacacionesKpi.service';
import { DatosBolsaVacacionesKpiModel } from '../../core/models/DatosBolsaVacacionesKpi.model';
import { VacacionesService } from '../../core/services/vacaciones.service';
import { DatosDiasVacacionesKpiModel } from '../../core/models/datosDiasVacacionesKpi.model';
import { SustitucionService } from '../../core/services/sustitucion.service';
import { DatosSustitucionesKpiModel } from '../../core/models/datosSustitucionesKpi.model';

import { DatosTiposSolicitudesModel, DatosSolicitudesMesVSModel } from '../../core/models/datosSolicitudes.model';
import { AppSolicitudesService } from '../../core/services/appSolicitudes.service';
import { AppEmpresas } from '../../core/models/appEmpresas.model';
import { AppEmpresasService } from '../../core/services/appEmpresasService.service';
import { LicenseCheckerService } from '../../core/helper/licenseChecker';
import { forkJoin } from 'rxjs';
import { MessageDialog } from '../../components/message-dialog/messageDialog';
import { Configuration } from '../../core/configuration/configuration';
import { LivesSessionHelper } from '../../core/helper/livesSessionHelper';
@Component({
  selector: 'app-welcome-dashboard',
  templateUrl: './welcome-dashboard.component.html',
  styleUrls: ['./welcome-dashboard.component.css'],
  providers: [DatosBolsaVacacionesKpiService, VacacionesService, SustitucionService, LicenseCheckerService, AppSolicitudesService, AppEmpresasService]
})
export class WelcomeDashboardComponent implements AfterViewInit {

  datosKpiBolsaVacaciones = new Array<DatosBolsaVacacionesKpiModel>();
  datosTiposSolicitudes = new Array<DatosTiposSolicitudesModel>();
  datosSolicitudesMesVS = new Array<DatosSolicitudesMesVSModel>();

  totalBV: number;
  pagadoBV: number;
  pendienteBV: number;
  porcentajePagado: number;
  porcentajePendiente: number;

  datosKpiDiasVacaciones: DatosDiasVacacionesKpiModel;
  datosKpiSustituciones: DatosSustitucionesKpiModel;

  selectedLivesCompany: number = 1;
  selectedLivesYear: number;

  selectedCompany: number = 1;
  selectedYear: number;

  hostelLicence: Boolean;
  livesAppLicence: Boolean;
  attendanceLicence: Boolean;
  isLoadingRequests: boolean = false;
  environmentId: string;
  popupCompaniesDisplayed: boolean = false;


  // modalId = 'firstStepVideo';

  constructor(
    private datosBolsaVacacionesKpiService: DatosBolsaVacacionesKpiService,
    private vacacionesService: VacacionesService,
    private sustitucionesService: SustitucionService,
    private appSolicitudesService: AppSolicitudesService,
    private appEmpresasService: AppEmpresasService,
    private _session: SessionHelper,
    private ngxSmartModal: NgxSmartModalService,
    private licenseChecker: LicenseCheckerService,
    protected _messageDialog: MessageDialog,
    private _livesSession: LivesSessionHelper
  ) {
    const dateNow = new Date();
    this.selectedYear = dateNow.getFullYear();
    this.hostelLicence = this.licenseChecker.checkLicense("hostelHR");
    this.livesAppLicence = this.licenseChecker.checkLicense("livesHR");
    this.attendanceLicence = this.licenseChecker.checkLicense("attendance");
    this.environmentId = this._livesSession.EnvironmentId;
    this.popupCompaniesDisplayed = this._livesSession.PopupCompaniesDisplayed === 'true';
    this.hostelLicence && this.loadKpiData();
    this.livesAppLicence && this.loadRequestsData();
  }

  ngOnInit() {
    this.appEmpresasService.getAllModelsByEnvironment(this.environmentId).subscribe(
      (response) => {
        if (Array.isArray(response) && response.length === 0 && !this.popupCompaniesDisplayed && !this.isAdmin()) {
          this._messageDialog.ShowInfoHTML('Aún no tiene una empresa asignada. Consulte con el Administrador para realizar la asignación.', 'Sin acceso a empresas', true);
          this._livesSession.PopupCompaniesDisplayed = 'true';
        }
      },
      (error) => {
        console.error("Error en getAllModelsByEnvironment:", error);
      }
    );
  }


  ngAfterViewInit() {
  }

  navigate(url: string) {
    window.open(url, '_blank');
  }

  customizeLabel(arg) {
    return `${arg.percentText}`;
  }

  loadKpiData() {

    this.sustitucionesService.getKpiDataByCompany(this.selectedCompany, this.selectedYear).subscribe(datos => {
      if (datos) {
        this.datosKpiSustituciones = datos;
      }
    }, error => console.error(error));

    this.vacacionesService.getKpiDataByCompanyAndYear(this.selectedCompany, this.selectedYear).subscribe(datos => {
      if (datos) {
        this.datosKpiDiasVacaciones = datos;
      }
    }, error => console.error(error));

    this.datosBolsaVacacionesKpiService.getData(this.selectedCompany, this.selectedYear).subscribe(datos => {
      if (datos) {
        this.datosKpiBolsaVacaciones = datos;
        this.totalBV = datos[0]?.TotalBolsaVacaciones ?? 0;
        this.pagadoBV = datos.reduce((sum, current) => sum + current.TotalPagado, 0);
        this.pendienteBV = this.totalBV - this.pagadoBV;
        this.porcentajePendiente = this.pendienteBV * 100 / this.totalBV;
        this.porcentajePagado = 100 - this.porcentajePendiente;
      }
    }, error => console.error(error));

  }

  //LivesHR
  companySelectedChanged(companyCode: number) {
    this.selectedLivesCompany = companyCode[0].companyCode;
  }

  loadRequestsData() {
    this.isLoadingRequests = true;

    forkJoin([
      this.appSolicitudesService.getTypesGraphsData(this.selectedLivesCompany, this.selectedLivesYear),
      this.appSolicitudesService.getMonthsVSGraphsData(this.selectedLivesCompany, this.selectedLivesYear)
    ]).subscribe(
      ([datosTipos, datosMesesVS]) => {
        if (datosTipos) {
          this.datosTiposSolicitudes = datosTipos;
        }
        if (datosMesesVS) {
          this.datosSolicitudesMesVS = datosMesesVS;
        }
        this.isLoadingRequests = false;
      },
      error => {
        console.error(error);
        this.isLoadingRequests = false;
      }
    );
  }

  isAdmin() {
    return this._session.User.Roles?.includes(Configuration.rolAdministrador) || false
  }

}


